import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {PaymentsResponse, Policy} from "@ferry/journey-services";
import {Overlay} from "@athena-portal/components";
import type {ICustomerPortalService} from "../services/ICustomerPortalService";
import {Types} from "../Types";

interface IProps {
    quoteInteraction?: any
}

interface IState {
    payments?: PaymentsResponse,
    policies?: Policy[]
}

export class PricingExplainedInfo extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    // TODO: banners should not load data from backend, it should be passed as props
    public componentDidMount(): void {
        // this.customerPortalService.getPaymentHistory().subscribe(
        //     (payments: PaymentsResponse) => {
        //         this.setState({payments})
        //     }
        // );

        this.customerPortalService.getPolicies().subscribe(
            (policies: Policy[]) => {
                this.setState({policies});
            }
        );
    }

    public render(): React.ReactNode {
        return <Overlay show={true}/>
    }
}

